import React from 'react';
import { Form, Input, InputNumber } from 'antd';
import '../../../assets/sass/_form-element.scss';

const { TextArea } = Input;

export default function CustomInput({
  editMode = true,
  value,
  name,
  rules,
  type = 'text',
  icon = null,
  label,
  inputValue,
  isForm = true,
  ...rest
}) {
  const renderEls = () => {
    if (type === 'number') return <InputNumber {...rest} disabled={!editMode} />;
    if (type === 'textarea') return <TextArea {...rest} disabled={!editMode} />;
    if (type === 'password') return <Input.Password {...rest} disabled={!editMode} />;
    return <Input {...rest} value={inputValue} disabled={!editMode} />;
  };
  return (
    <div className={`form-element ${editMode ? 'editor-mode' : 'view-mode'}`}>
      {icon && <img className="fixed-icon" src={icon} alt="icon" />}
      {isForm ? (
        <Form.Item name={name} rules={rules} label={label}>
          {renderEls()}
        </Form.Item>
      ) : (
        renderEls()
      )}
    </div>
  );
}
